<template>
  <div class="childtrackingsystem-triggers">
    <div
      v-if="isLoading"
      class="row bg-white"
    >
      <div class="col-12 text-center">
        <img
          src="../../assets/img/loading.gif"
          alt="Loading"
          style="width: 80px; height: 80px;"
        >
      </div>
    </div>
    <div
      v-if="!isAnalyse"
      class="row bg-white pt-3 pb-3"
    >
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedMentor"
        >Invuller</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="mentor"
          placeholder="Zoek..."
          name="mentor"
          list="mentors-list"
          v-model="searchedMentor"
          @focus="searchedMentor = ''; document.getElementById('mentors-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="mentors-list">
          <option value="Alle" selected></option>
          <option
            v-for="mentor in mentors"
            :value="mentor.name"
            :key="mentor.id"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="selectedList"
        >Observatielijst</label>
        <input
          type="search"
          class="form-select form-select-sm"
          id="selectedList"
          placeholder="Zoek..."
          name="selectedList"
          list="lists-list"
          v-model="searchedList"
          @focus="searchedList = ''; document.getElementById('lists-list').style.display='block';"
          @change="searchResults()"
        />
        <datalist id="lists-list">
          <option value="Alle" selected></option>
          <option
            v-for="list in lists"
            :key="list.id"
            :value="list.title"
          >
          </option>
        </datalist>
      </div>
      <div class="col-md-4">
        <label
          class="form-label"
          for="filterChildren"
        >Filter kinderen</label>
        <select
          class="form-select form-select-sm"
          id="filterChildren"
          name="filterChildren"
          v-model="selectedFilterChildren"
          @change="getResults()"
        >
          <option value="all">Alle</option>
          <option value="present">Aanwezig</option>
          <option value="vve">VVE</option>
        </select>
      </div>
    </div>
    <div
      v-if="!isAnalyse"
      class="row bg-white"
    >
      <div class="col-md-12"><br>
        <table class="table">
          <thead>
            <tr>
              <th>Observatielijst <span
                data-bs-toggle="modal"
                data-bs-target="#infoModal"
              >
                    <icon name="info"></icon>
                </span>
              </th>
              <th class="text-end pe-1">

              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(trigger, key) in results"
              v-bind:key="key"
            >
              <td><b>{{ trigger.listTitle }}</b> van kind <b>{{ trigger.childName }}</b> opgeslagen op
                {{ trigger.dateAnalyse }} (herinneringsdatum: {{ trigger.dateTrigger }})
              </td>
              <td
                class="text-end me-1"
                style="width:120px;"
              >
              <span
                style="margin-top: 5px; margin-right: 15px;color:#666;"
                title="Bekijk"
                @click="openAnalyse(trigger.idResult)"
              >
                <icon name="look-into"></icon>
              </span>
                <span
                  style="margin-top: 5px; margin-right: 15px;"
                  title="Wis"
                  @click="deleteTrigger(trigger.id)"
                >
                <icon name="delete"></icon>
              </span>
              </td>
            </tr>
            <tr v-if="results.length === 0">
              <td colspan="7">Geen herinneringen actief</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="modal fade"
      id="infoModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <icon name="look-into"></icon>
              </div>
              <div class="col-9">Bekijk observatielijst</div>
            </div>
            <div class="row">
              <div class="col-3">
                <icon name="delete"></icon>
              </div>
              <div class="col-9">Verwijder herinnering</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAnalyse">
      <childtrackingsystem-editchildobservationlist :idResult="selectedResult"></childtrackingsystem-editchildobservationlist>
    </div>
  </div>
</template>
<script>
import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
import icon from "@/components/Icon.vue";

export default {
  name: 'childtrackingsystem-triggers',
  components: { icon, ChildtrackingsystemEditchildobservationlist },
  data() {
    return {
      isLoading: false,
      results: [],
      isAnalyse: false,
      analysedChildren: [],
      listTitle: null,
      categories: [],
      answers: [],
      checkedAnswer: [],
      checkedList: null,
      idResult: null,
      childId: null,
      listId: null,
      categoryId: null,
      isModalInfo: false,
      selectedResult: 0,
      lists: [],
      selectedList: 0,
      searchedList: 'Alle',
      mentors: [],
      searchedMentor: 'Alle',
      selectedMentor: 0,
      filterChildren: [],
      selectedFilterChildren: 'all'
    };
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken;
    },
    session() {
      return this.$store.getters.session;
    }
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    };
    this.getResults();
  },
  methods: {
    getResults() {
      this.isLoading = true;
      this.$store.commit('REGISTER_ACTIVE_REQUEST');
      this.$request.post('/ChildTrackingSystem/triggers', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedMentor: this.selectedMentor,
        selectedList: this.selectedList,
        selectedFilterChildren: this.selectedFilterChildren
      }).then((response) => {
        this.isLoading = false;
        this.$store.commit('REMOVE_ACTIVE_REQUEST');
        if (response.triggers) {
          this.results = response.triggers;
          if (this.lists.length < 1) {
            this.lists = response.lists;
          }
          if (this.mentors.length < 1) {
            this.mentors = response.mentors;
          }
        }
      });
    },
    searchResults() {
      if (this.searchedMentor === 'Alle') {
        this.selectedMentor = 0;
      } else {
        this.mentors.forEach(mentor => {
          if (mentor.name.toLowerCase().includes(this.searchedMentor.toLowerCase())) {
            this.selectedMentor = mentor.id
          }
        })
      }
      if (this.searchedList === 'Alle') {
        this.selectedList = 0;
      } else {
        this.lists.forEach(list => {
          if (list.title.toLowerCase().includes(this.searchedList.toLowerCase())) {
            this.selectedList = list.id
          }
        })
      }
      document.activeElement.blur()
      this.getResults()
    },
    deleteTrigger(idTrigger) {
      if (confirm('Weet u zeker dat u de herinnering wilt verwijderen?')) {
        this.isLoading = true;
        this.$store.commit('REGISTER_ACTIVE_REQUEST');
        this.$request.post('/ChildTrackingSystem/deleteTrigger', {
          idTrigger: idTrigger
        }).then((response) => {
          this.$store.commit('REMOVE_ACTIVE_REQUEST');
          if (response) {
            this.isLoading = false;
            this.isAnalyse = false;
            this.getResults();
          }
        });
      }
    },
    openAnalyse(idResult) {
      this.isAnalyse = true;
      this.selectedResult = idResult;
    }
  }
};
</script>
<style scoped>
.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}

.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.modalInfo {
  position: absolute;
  z-index: 1;
  left: 100px;
  top: 100px;
  width: 500px;
  height: 330px;
  overflow: auto;

}
</style>